//messages.js
export default {
    distributor_id: "Distributor ID",
    parent_id: "Parent ID",
    stripe_id: "Stripe ID",
    zoho_customer_id: "Zoho Customer ID",
    organisation_type_id: "Organisation Type ID",
    distributor: "Distributor",
    company: "Company",
    company_short: "Company Short",
    website: "Website",
    correspondence_method: "Correspondence Method",
    currency_code: "Currency Code",
    turn_around_days: "Turn Around Days",
    has_nda: "Has Nda",
    has_contract: "Has Contract",
    ship_label_type: "Ship Label Type",
    logo_id: "Logo ID",
    logo: "Logo",
    status: "Status",
    edit_distributor: "Edit Distributor",
    add_distributor: "Add Distributor",
    delete_distributor: "Delete Distributor",
    distributors: "Distributors",
    delete_distributor_confirm: "This action is not reversible!",
    modify_distributor: "Modify Distributor",
};
